import { z } from 'zod';
import { apiGet } from '@/lib/api';

/**
 * RUCH POWIERZCHNI `/api/v1` — dane pod sekcję „Ruch API" w „Konta i API".
 *
 * ⚠️ DWA WYWOŁANIA, NIE JEDNO. Przegląd (kafle, wykres, endpointy) zmienia się rzadko i jedzie
 * w całości, a lista ostatnich żądań ma filtry, więc odświeża się przy każdej ich zmianie.
 * Wspólny adres znaczyłby przeliczanie agregatów przy każdym kliknięciu w rozwijaną listę.
 */
const PrzegladSchema = z.object({
  kafle: z.object({
    zapytan24h: z.number(),
    zapytan7dni: z.number(),
    bledy24h: z.number(),
    procentBledow24h: z.number(),
    sredniCzasOk24h: z.number().nullable(),
    tokenow24h: z.number(),
    naToken24h: z.number().nullable(),
  }),
  wykres: z.array(z.object({ godzina: z.string(), ok: z.number(), bledy: z.number() })),
  endpointy: z.array(
    z.object({
      method: z.string(),
      route: z.string(),
      wywolania: z.number(),
      ok: z.number(),
      bledy: z.number(),
      sredniCzas: z.number().nullable(),
      ostatnio: z.string(),
      ostatniStatus: z.number(),
    }),
  ),
});

const ZadaniaSchema = z.object({
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
  rows: z.array(
    z.object({
      at: z.string(),
      method: z.string(),
      route: z.string(),
      status: z.number(),
      durationMs: z.number(),
      ip: z.string().nullable(),
      tokenLabel: z.string().nullable(),
    }),
  ),
  metody: z.array(z.string()),
  statusy: z.array(z.number()),
  adresy: z.array(z.string()),
});

export type RuchPrzeglad = z.infer<typeof PrzegladSchema>;
export type RuchZadania = z.infer<typeof ZadaniaSchema>;

export const fetchRuchPrzeglad = () => apiGet('/ruch-api/przeglad', PrzegladSchema);

export const fetchRuchZadania = (f: { metoda?: string; status?: number; ip?: string; page?: number }) => {
  const p = new URLSearchParams();
  if (f.metoda) p.set('metoda', f.metoda);
  if (f.status !== undefined) p.set('status', String(f.status));
  if (f.ip) p.set('ip', f.ip);
  if (f.page !== undefined && f.page > 1) p.set('page', String(f.page));
  const q = p.toString();
  return apiGet(`/ruch-api/zadania${q === '' ? '' : `?${q}`}`, ZadaniaSchema);
};
